import React, { useMemo } from "react";
import { FilterList, FilterListItem } from "./FilterList";

interface ExposureRangesFilterListProps {
  selectedRanges: string[];
  onToggle: (range: string) => void;
  title?: string;
  pinnedRanges?: string[];
  onTogglePin?: (range: string) => void;
  colorByMode?: string;
  onColorByToggle?: () => void;
  colorByValue?: string; // הערך המתאים לסוג החשיפה הזה
  ranges: string[]; // טווחי החשיפה הספציפיים לסוג החשיפה
  rangeColors: Record<string, string>; // הצבעים לטווחים
}

export const ExposureRangesFilterList: React.FC<
  ExposureRangesFilterListProps
> = ({ selectedRanges, onToggle, title, pinnedRanges, onTogglePin, colorByMode, onColorByToggle, colorByValue, ranges, rangeColors }) => {
  const items: FilterListItem[] = useMemo(() => {
    return ranges.map((range) => ({
      value: range,
      label: `${range}%`,
      color: rangeColors[range],
    }));
  }, [ranges, rangeColors]);

  return (
    <FilterList
      items={items}
      selectedValues={selectedRanges}
      onToggle={onToggle}
      showColorIndicator={true}
      title={title}
      pinnedValues={pinnedRanges}
      onTogglePin={onTogglePin}
      colorByMode={colorByMode}
      onColorByToggle={onColorByToggle}
      colorByValue={colorByValue}
    />
  );
};
